//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";
import pointName from "../../../../utils/pointName";
import unitsservice from "../../../../utils/units";
import { array, string } from "../../../../utils";
import ruleservice from "../../../../services/rules";

const initialState = {
	instances: {}
};

/////////
//types
export const types = {
	INIT_TABLE: "component/diagnosticstable/INIT_TABLE",
	LOAD_DATA: "component/diagnosticstable/LOAD_DATA",
	SET_TABLE_DATA: "component/diagnosticstable/SET_TABLE_DATA"
};

function initTable(state, action) {
	const id = action.payload.id;
	const ruleInstance = action.payload.ruleInstance;
	//do nothing if it's already init
	if (state.instances.id) {
		return state;
	}
	let tableData = {
		rows: []
	};
	let newState = { ...state, instances: { ...state.instances, [id]: tableData } };
	return newState;
}

function setTableData(state, action) {
	const id = action.payload.id;
	const tableData = action.payload.tableData;
	return { ...state, instances: { ...state.instances, [id]: tableData } };
}

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.INIT_TABLE: {
				return initTable(state, action);
			}
			case types.LOAD_DATA: {
				return state;
			}
			case types.SET_TABLE_DATA: {
				return setTableData(state, action);
			}
			default:
				return state;
		}
	}
};

function* addPointDataAsync(wkInput, pointId, coV, index) {
	if (wkInput.source === "RuleInstance") {
		return yield call(pointsservice.GetRuleInstance, pointId);
	} else if (wkInput.source === "IEnergy") {
		return yield call(pointsservice.TrendableObjectGetObject, pointId);
	}
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadData()]);
	},

	*loadData() {
		yield takeEvery(types.LOAD_DATA, function*({ payload }) {
			const ruleInstance = payload.ruleInstance;
			const id = payload.id;
			const fromDate = payload.timePeriod.startDate;
			const toDate = payload.timePeriod.endDate;

			const tableData = {
				rows: []
			};

			const data = yield call(
				ruleservice.GetActionAudits,
				ruleInstance.ruleInstanceId,
				fromDate.toISOString(),
				toDate.toISOString()
			);

			if (data instanceof Error || !data) {
				return;
			} else {
				tableData.rows = data.map(x => ({
					name: x.destinationEmailSms,
					action: x.actionName,
					value: x.value,
					time: x.siteLocalTime
				}));
			}

			yield put(actions.setTableData(id, tableData));
		});
	}
};

////////
//actions
export const actions = {
	initTable(id, ruleInstance) {
		return {
			type: types.INIT_TABLE,
			payload: { id, ruleInstance }
		};
	},
	loadData(id, ruleInstance, timePeriod) {
		return {
			type: types.LOAD_DATA,
			payload: { id, ruleInstance, timePeriod }
		};
	},
	setTableData(id, tableData) {
		return {
			type: types.SET_TABLE_DATA,
			payload: { id, tableData }
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/DiagnosticOutput/redux.js